import React from 'react';
import { Button } from 'react-bootstrap';

import Accordion from 'components/Accordion';
import { Model } from 'helper/products/meteorology';
import ModelCheckbox from '../ModelCheckbox';

export default function ModelsAccordionItem({
  selectableModels,
  onAllClicked,
  onNoneClicked,
  eventKey,
}: {
  selectableModels: Model[],
  onAllClicked: () => void,
  onNoneClicked: () => void,
  eventKey: string,
}) {
  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>Modelo</Accordion.Header>
      {selectableModels.length === 0 && (
        <Accordion.Body className="w-100">
          Selecione uma variável
        </Accordion.Body>
      )}
      {selectableModels.length > 0 && (
        <Accordion.Body className="d-grid control-panel-columns">
          {selectableModels.map((m) => (
            <ModelCheckbox key={m.value} value={m.value} label={m.label} />
          ))}
          <div className="d-grid mt-2" style={{ gridColumn: '1 / -1', gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
            <Button variant="outline-primary" size="sm" onClick={onAllClicked}>Todos</Button>
            <span />
            <Button variant="outline-primary" size="sm" onClick={onNoneClicked}>Nenhum</Button>
          </div>
        </Accordion.Body>
      )}
    </Accordion.Item>
  );
}
